import { createFileRoute, redirect } from '@tanstack/react-router'
import { ArticleEditorView } from '../../../components/knowledge/ArticleEditorView'
import { isPublicKbHost } from '../../../lib/public-kb-host'

export const Route = createFileRoute('/knowledge/$workspaceId/$articleId')({
  beforeLoad: () => {
    if (isPublicKbHost()) {
      throw redirect({ to: '/knowledge' })
    }
  },
  component: KnowledgeArticlePage,
})

function KnowledgeArticlePage() {
  const { workspaceId, articleId } = Route.useParams()
  const { workspace } = Route.useRouteContext()

  return (
    <ArticleEditorView
      workspaceId={workspaceId}
      workspaceName={workspace.name}
      articleId={articleId}
    />
  )
}
